export default __webpack_public_path__ + "static/media/section2b-grid8img.49088e69.svg";